module.exports = __webpack_public_path__ + "img/microbiology.5d187f68.svg";